import {VanillaVoidCallback} from '../VanillaReader/VanillaReaderModel';

/**
 * # VanillaReaderUiGuidedReadingContentMask
 *
 * ## RESPONSIBILITIES
 *
 * A floating action button that is shown when ever the guided reading mode is available for a publication.
 * The button toggles the player on and off.
 *
 * ## RELATED TYPES
 * - VanillaReaderUiGuidedReadingContentMask
 *
 */
export class VanillaReaderUiFabGuidedPlayerToggle {
    private _template = `<button class="vanilla-reader__fab" id="vanilla-reader__fab-guided-reading-player-toggle" type="button" title="Toggle Guided Reading mode" aria-hidden="true"><span class="vanilla-reader__fab__icon" id="vanilla-reader__fab-guided-reading-player-toggle__icon" aria-hidden="true">near_me</span></button>`;
    private _onClickCallback: VanillaVoidCallback | undefined;
    private _onVisibleCallback: VanillaVoidCallback | undefined;
    private _onHiddenCallback: VanillaVoidCallback | undefined;
    private _toggleButton: HTMLButtonElement;
    private _toggleButtonIcon: HTMLElement;
    private _isActive: boolean = false;

    constructor(private _hostElement: HTMLElement, insertPosition: InsertPosition = 'afterbegin') {
        this._hostElement.insertAdjacentHTML(insertPosition, this._template);
        this._toggleButton = this._hostElement.querySelector('#vanilla-reader__fab-guided-reading-player-toggle')!;
        this._toggleButtonIcon = this._hostElement.querySelector('#vanilla-reader__fab-guided-reading-player-toggle__icon')!;
        this._toggleButton.addEventListener('click', (ev: MouseEvent) => {
            ev.preventDefault();
            ev.stopImmediatePropagation();
            if (this._onClickCallback) {
                if (this.isVisible) {
                    this._isActive = !this._isActive;
                    this._toggleButtonIcon.innerText = this._isActive ? 'near_me_disabled' : 'near_me';
                    this._onClickCallback();
                }
            }
        });

    }

    public get isVisible(): boolean {
        return !this._toggleButton.hasAttribute('aria-hidden');
    }

    public get active(): boolean {
        return this._isActive;
    }

    public set active(state: boolean) {
        this._isActive = state;
        this._setActiveState(state);
    }

    show(): void {
        this._toggleButton.removeAttribute('aria-hidden');
        this._toggleButton.style.display = 'flex';
        this._toggleButton.style.opacity = '1';
        this._toggleButton.style.pointerEvents = 'all';
        if (this._onVisibleCallback) {
            this._onVisibleCallback();
        }
    }

    hide(): void {
        this._toggleButton.setAttribute('aria-hidden', 'true');
        this._toggleButton.style.opacity = '0';
        this._toggleButton.style.pointerEvents = 'none';

        setTimeout(()=>{
            this._toggleButton.style.display = 'none';
        },200);

        if (this._onHiddenCallback) {
            this._onHiddenCallback();
        }
    }

    getComponentElement(): HTMLElement {
        return this._toggleButton;
    }

    onClick(callback: VanillaVoidCallback): void {
        this._onClickCallback = callback;

    }

    onVisible(callback: VanillaVoidCallback): void {
        this._onVisibleCallback = callback;
    }

    onHidden(callback: VanillaVoidCallback): void {
        this._onHiddenCallback = callback;
    }

    _setActiveState(state: boolean): void {
        this._toggleButtonIcon.innerText = state ? 'near_me_disabled' : 'near_me';
    }

}
